import { connectRouter } from 'connected-react-router'
import { focusReducer as focus } from 'focus'
import { notificationReducer as notification } from 'notification'
import { combineReducers } from 'redux'
import addressHelper from './addressHelperReducer'
import address from './addressReducer'
import articles from './articlesReducer'
import b2b from './B2BStateReducer'
import banner from './bannerReducer'
import businessInfo from './businessInfoReducer'
import campaign from './campaignReducer'
import cartNotification from './cartNotificationReducer'
import cart from './cartReducer'
import checkout from './checkoutReducer'
import conceptPage from './conceptPageReducer'
import coupon from './couponReducer'
import distribution from './distributionReducer'
import employees from './employeesReducer'
import features from './featuresReducer'
import freight from './freightReducer'
import gift from './giftReducer'
import homePage from './homePageReducer'
import newPaymentMethod from './newPaymentMethodReducer'
import order from './orderReducer'
import paymentMethod from './paymentMethodReducer'
import personalInfo from './personalInfoReducer'
import products from './productsReducer'
import push from './pushReducer'
import region from './regionReducer'
import search from './searchReducer'
import subscriptionNotification from './subscriptionNotificationReducer'
import subscription from './subscriptionReducer'
import ui from './uiReducer'
import user from './userReducer'

export default (history) =>
    combineReducers({
        address,
        addressHelper,
        articles,
        banner,
        businessInfo,
        b2b,
        campaign,
        cart,
        cartNotification,
        checkout,
        coupon,
        distribution,
        employees,
        features,
        focus,
        freight,
        gift,
        conceptPage,
        homePage,
        newPaymentMethod,
        notification,
        order,
        paymentMethod,
        personalInfo,
        products,
        push,
        region,
        router: connectRouter(history),
        search,
        subscription,
        subscriptionNotification,
        ui,
        user,
    })
